module.exports = __webpack_public_path__ + "img/3.ae4de91.png";